import React, { useState } from "react";

import { Outlet } from 'react-router-dom';
import { KoTitle, KoButton, KoAffix, KoDescription, KoTag, KoLoader, KoTooltips, KoToast } from 'packages';
import KoIcon from '@kwapio/icons';
import { useNavigate } from 'react-router-dom';
import styles from './details.module.scss';
import { useSelector } from "react-redux";
import ClientDetails from "./customersList/deatils";
import { getCookie } from "shared/utils/cookies";



function CustomerDetails() {
  const [loading] = useState(false);
  const accountById = useSelector(state => state?.accountById);
  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  let navigate = useNavigate();
  const accountDetails = accountById['data'];


  const copyLink = () => {
    const domain = window.location.origin;
    const accountId = getCookie('accountId');
    if (!accountId) {
      KoToast.error('Account ID not found');
      return;
    }
    const fullUrl = `${domain}/open/customer/${accountId}/public/new`;
    navigator.clipboard.writeText(fullUrl).then(() => KoToast.success('Copied to clipboard'));
  };


  return <>
    {loading && <KoLoader />}
    <div className={`${styles.wrapper}`}>
      <KoAffix top={50}>
        <div className={styles.dashboardHeader}>
          <div className={styles.headerWrapper}>
            <div className={styles.header}>
              <KoTitle ellipsis={true} text={'Customers'} level={1} />
              <KoButton className={styles.orgclass} label={`${accountDetails?.companyName}`} type='text' icon={<KoIcon name={'OrgOutlined'} width={18} height={18} />} />
              {accountDetails?.PAN && <KoTag ellipsis={true} iscount={false} value={`PAN/EIN: ${accountDetails?.PAN} `} color='color-1' radius={false} custom={true} />}
            </div>
            <div className={styles.projectFilter}>
              <KoTooltips title={'Copy the ‘Create Customer’ form'} >
                <KoButton onClick={() => copyLink()} icon={<KoIcon color='#FFF' name='CopyOutlined' />} iconBtn={true} />
              </KoTooltips>
              <KoButton onClick={() => setOpenCustomerModal(true)} type='primary' icon={<KoIcon color='#FFF' name='PlusOutlined' />} label={`Create Customer`} />
            </div>
          </div>
          <KoDescription text={`Centralize customer data and streamline outreach across email, SMS, WhatsApp, and reminders.
Easily monitor subscription status and manage communications at scale.`} className={styles.description} />
        </div>
      </KoAffix>
      <Outlet />
      {openCustomerModal&& <ClientDetails getCustomers={() =>   navigate(`/customers/details`)} setCurrentRecord={() => setOpenCustomerModal(false)}  openCustomerModal={openCustomerModal} setOpenCustomerModal={() => setOpenCustomerModal(false)} />}

    </div>

  </>;

}

export default CustomerDetails;